import React from "react";
import getSize from "../../../utils/getSize";
import NHTable from '../../common/NHTable';
import css from './index.css';
import { message, Button, Table, Select, Input } from 'antd';
import { hasAuth, createUuid } from "../../../utils/NHCore";
/**
 * 住宿信息查询
 * @author sujunming
 * @date 2018-08-04 15:45:03
 * Version: 1.0
 */
class ZsxxIndex extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            initParams: {},
            selectKey: '',
            columns: [],
        }
    }


    handleOtpBtnClick = () => {
        this.refs.nhTable.exportExcel('住宿信息');
    }

    render() {
        const columnConst = [
            {
                title: '序号',
                dataIndex: 'ROW_ID',
                width: '50px',
            }, {
                title: '学号',
                dataIndex: 'XH',
                width: '120px',
                searchType:"input"
            }, {
                title: '姓名',
                dataIndex: 'XM',
                width: '90px',
                search: 'input',
                searchType:"input"
            }, {
                title: '性别',
                width: '70px',
                dataIndex: 'XB',
                searchType:"select"
            }, {
                title: '身份证号',
                dataIndex: 'SFZJH',
                width: '160px',
                searchType:"input"
            }, {
                title: '院系',
                width: '120px',
                dataIndex: 'BMMC',
                searchType:"select"
            }, {
                title: '专业',
                width: '200px',
                dataIndex: 'ZYMC',
                searchType:"select",
                parentField:"BMMC"
            }, {
                title: '班级',
                width: '200px',
                dataIndex: 'BJMC',
                searchType:"select",
                parentField:"ZYMC"
            }, {
                title: '校区名称',
                width: '100px',
                dataIndex: 'XQMC',
                searchType:"select"
            }, {
                title: '楼栋名称',
                width: '100px',
                dataIndex: 'LDMC',
                searchType:"input"
            }, {
                title: '楼层名称',
                width: '100px',
                dataIndex: 'LCMC',
                searchType:"input"
            }, {
                title: '房间名称',
                width: '100px',
                dataIndex: 'FJMC',
                searchType:"input"
            }, {
                title: '床位号',
                width: '100px',
                dataIndex: 'CWH',
                searchType:"input"
            }, {
                title: '入住状态',
                width: '100px',
                dataIndex: 'RZZTMC',
                searchType:"select"
            }, {
                title: '入住方式',
                width: '100px',
                dataIndex: 'RZFS',
                searchType:"select"
            }, {
                title: '入住时间',
                width: '145px',
                dataIndex: 'RZSJ',
                commonSearch: false,
                searchType:"date"
            }
        ];

        return (
            <div className={css.main_right_content} style={{height: getSize().windowH - 123}}>
                <div style={{width: '100%', height: '100%',}}>
                    <NHTable
                        ref='nhTable'
                        rowKey={record => record.PKID}
                        sign={"zhxg_yxxt_tjcx_zsxxcx_queryPage"}
                        columns={columnConst}
                        rangeFilter={true}
                    >
                        {hasAuth("zhxg_yxgl_tjcx_zsxxcx:export") ?
                            <Button type="primary" ghost onClick={this.handleOtpBtnClick}
                                    style={{marginLeft: 10}}>导出</Button> : undefined}
                    </NHTable>

                </div>
            </div>
        )
    }
}

export default ZsxxIndex;



// WEBPACK FOOTER //
// ./components/tjcx/zsxxcx/index.js